/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function IndexHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
          {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-home-mobile.jpg")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-home-1024.jpg")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/header.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default IndexHeader;